import { captureException } from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import { Error } from '~/components/Errors/Error';

/**
 * Throwing an error somewhere in the application and not handling it ad hoc will cause this component to be used.
 * It currently handlers urql errors, any custom created errors and dynamic import errors.
 *
 * @example ```js
 * const [{data, error}] = useQuery({...});
 * throw new ApplicationError(error.message, error);
 * ```
 * @example ```js
 * const [{data, error}] = useQuery({...});
 * throw new CombinedError(error);
 * ```
 */
export function ErrorPage() {
    const routeError = useRouteError();

    useEffect(() => {
        captureException(routeError);
    }, [routeError]);

    return <Error error={routeError} />;
}
